import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

interface Props {
    children: JSX.Element;
}

export const useDndProvider = () => {
    const [dndArea, setDndArea] = React.useState();
    const handleRef = React.useCallback((node) => setDndArea(node), []);
    const html5Options = React.useMemo(() => ({ rootElement: dndArea }), [dndArea]);
    return { dndArea, handleRef, html5Options };
};

export const DndProviderWrapper = (props: Props) => {
    const { dndArea, handleRef, html5Options } = useDndProvider();
    return (
        <div ref={handleRef}>
            {dndArea && (
                <DndProvider backend={HTML5Backend} options={html5Options}>
                    {props.children}
                </DndProvider>
            )}
        </div>
    );
};
